import React, { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import SydModalActions from '../../../../../../commonDesign/SydModal/SydModalActions'
import SydButton from '../../../../../../commonDesign/Button'
import SydInput from '../../../../../../commonDesign/SydInput'
import SydLabel from '../../../../../../commonDesign/SydLabel'
import SydSelect from '../../../../../../commonDesign/SydSelect'
import { useInvalidatePeopleSearch, useModifyPersonMutation } from '../../../../../../../api/people'
import ErrorDisplay from '../../../../../../molecules/ErrorDisplay'
import { usePersonTypeOptions } from '../../../../../../pages/admin/ClientDetails/PeopleTab/usePersonTypeOptions'

const useStyles = makeStyles(() => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1rem 0'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: '1rem'
  },
  fullWidth: {
    width: '100%'
  }
}))

export default function EditPersonForm ({
  defaultValues,
  onSubmit: _onSubmit,
  onCancel
}) {
  const classes = useStyles()
  const { data: personTypeOptions, isLoading: isLoadingTypes } = usePersonTypeOptions()
  const queryCallback = useInvalidatePeopleSearch()
  const { mutateAsync: updatePerson, isLoading, error } = useModifyPersonMutation()

  const form = useForm({
    defaultValues: {
      firstName: defaultValues?.data?.firstName || '',
      lastName: defaultValues?.data?.lastName || '',
      email: defaultValues?.data?.email || '',
      personTypeId: defaultValues?.data?.personTypeId || '',
      personId: defaultValues?.levelId || 0
    }
  })

  useEffect(() => {
    if (defaultValues) {
      form.reset({
        firstName: defaultValues?.data?.firstName || '',
        lastName: defaultValues?.data?.lastName || '',
        email: defaultValues?.data?.email || '',
        personTypeId: defaultValues?.data?.personTypeId || '',
        personId: defaultValues?.levelId || 0
      })
    }
  }, [defaultValues, form])

  const onSubmit = async (data) => {
    const result = await updatePerson(data)
    if (result?.data?.success) {
      queryCallback()
      _onSubmit?.({
        ...defaultValues,
        data: {
          ...defaultValues.data,
          ...data,
          label: data.firstName + ' ' + data.lastName
        }
      })
    }
  }

  return (
    <form onSubmit={form.handleSubmit(onSubmit)} className={classes.form}>
      <div className={classes.row}>
        <Controller
          name='firstName'
          control={form.control}
          render={(f) => (
            <SydLabel label='First Name' className={classes.fullWidth}>
              <SydInput {...f.field} />
            </SydLabel>
          )}
        />
        <Controller
          name='lastName'
          control={form.control}
          render={(f) => (
            <SydLabel label='Last Name' className={classes.fullWidth}>
              <SydInput {...f.field} />
            </SydLabel>
          )}
        />
      </div>
      <div className={classes.row}>
        <Controller
          name='email'
          control={form.control}
          render={(f) => (
            <SydLabel label='Email' className={classes.fullWidth}>
              <SydInput {...f.field} />
            </SydLabel>
          )}
        />
      </div>
      {!isLoadingTypes && (
        <div className={classes.row}>
          <Controller
            name='personTypeId'
            control={form.control}
            render={(f) => (
              <SydLabel label='Person Type' className={classes.fullWidth}>
                <SydSelect {...f.field} options={personTypeOptions} />
              </SydLabel>
            )}
          />
        </div>
      )}
      {error && (
        <div className={classes.row}>
          <ErrorDisplay error={error?.toString()} />
        </div>
      )}
      <SydModalActions>
        <SydButton variant='secondary' size='md' onClick={onCancel}>Cancel</SydButton>
        <SydButton variant='primary' size='md' type='submit' processing={isLoading}>Save</SydButton>
      </SydModalActions>
    </form>
  )
}

EditPersonForm.propTypes = {
  defaultValues: PropTypes.shape({
    levelId: PropTypes.number,
    data: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      personTypeId: PropTypes.number
    })
  }),
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func
}
